// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Slideshow-module--carousel--eksvP","legend":"Slideshow-module--legend--15hhx"};